import React, { useState } from 'react';
import { useThemeMode } from '../../../../context/contextTheme';
import GlobalCyberLaw from './_global';
import IndianCyberLaw from './_india';
import USACyberLaw from './_usa';
import UKCyberLaw from './_uk';

const buttonsData = [
  { title: 'Global Cyber Law', icon: 'bi-shield-check', component: () => <GlobalCyberLaw /> },
  { title: 'Indian Cyber Law', icon: 'bi-building-fill-lock', component: () => <IndianCyberLaw /> },
  { title: 'USA Cyber Law', icon: 'bi-flag-fill', component: () => <USACyberLaw /> },
  { title: 'UK Cyber Law', icon: 'bi-shield-shaded', component: () => <UKCyberLaw /> },
];

const CyberLaw = () => {
  const { theme } = useThemeMode();
  const [selectedCard, setSelectedCard] = useState('Global Cyber Law');
  
  return (
    <div className="d-flex h-100 w-100 overflow-hidden">
      
      {/* LEFT SIDEBAR: NATIVE SEGMENT LIST CONTROLS */}
      <div 
        className="d-flex flex-column gap-2 p-3 border-end"
        style={{ 
          width: "260px", 
          backgroundColor: theme.cardBg ?? "#f8fafc", // Safely map to theme background config fallback layers
          minWidth: "260px"
        }}
      >
        <span 
          className="text-uppercase small fw-bold text-muted px-2 mb-2" 
          style={{ fontSize: '0.68rem', letterSpacing: '0.5px', color: theme.textMuted }}
        >
          Select Jurisdiction
        </span>
        
        {buttonsData.map((button) => {
          const isActive = selectedCard === button.title;
          return (
            <button
              key={button.title}
              type="button"
              className="btn text-start d-flex align-items-center gap-3 px-3 py-2.5 border-0 text-truncate"
              style={{
                borderRadius: "10px",
                fontSize: "0.88rem",
                fontWeight: isActive ? "600" : "500",
                backgroundColor: isActive ? (theme.primary ?? "#3b82f6") : "transparent",
                color: isActive ? "#ffffff" : (theme.textColor ?? "#1e293b"),
                boxShadow: isActive ? "0 4px 12px rgba(0,0,0,0.08)" : "none",
                transition: "all 0.2s ease"
              }}
              onClick={() => setSelectedCard(button.title)}
            >
              <i 
                className={`bi ${button.icon || 'bi-journal-text'} fs-5`} 
                style={{ 
                  color: isActive ? "#ffffff" : (theme.primary ?? "#3b82f6"),
                  width: "20px", // Locks vertical baseline box width for absolute row symmetry
                  textAlign: "center"
                }}
              />
              <span>{button.title}</span>
            </button>
          );
        })}
      </div>
      <div 
        className="flex-grow-1 p-4 overflow-y-auto custom-law-scroller"
        style={{ 
          backgroundColor: theme.background ?? "#ffffff",
          color: theme.textColor ?? "#1e293b"
        }}
      >
        <div className="fade-in-subview">
          {buttonsData.find(btn => btn.title === selectedCard)?.component()}
        </div>
      </div>
      <style>{`
        .custom-law-scroller::-webkit-scrollbar { width: 6px; }
        .custom-law-scroller::-webkit-scrollbar-track { background: transparent; }
        .custom-law-scroller::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
        .custom-law-scroller::-webkit-scrollbar-thumb:hover { background: #94a3b8; }
        
        .fade-in-subview {
          animation: lawSubViewAnimate 0.22s cubic-bezier(0.4, 0, 0.2, 1);
        }
        @keyframes lawSubViewAnimate {
          from { opacity: 0; transform: translateY(4px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default CyberLaw;